import { useQuery } from "react-query";
import { JobHttpService } from "../service";

const normalizeApplicationResponse = (response, jobId) => {
    if (!response) return { results: [] };
    const results = Array.isArray(response?.results)
        ? response.results
        : Array.isArray(response)
            ? response
            : [];

    const filtered = jobId
        ? results.filter((application) => {
            const relatedJob = application.job?.id ?? application.job;
            return Number(relatedJob) === Number(jobId);
        })
        : results;

    return {
        ...response,
        results: filtered
    };
};

const UseJobApplications = (jobId, options = {}) => {
    return useQuery(
        ["job_applications", jobId],
        async () => {
            const response = await JobHttpService.loadJobApplications({ jobId });
            return normalizeApplicationResponse(response, jobId);
        },
        {
            enabled: Boolean(jobId),
            ...options
        }
    );
};

export default UseJobApplications;

